export default {
  shiftSwaps: {
    availableShift: 101141,// Available Shift
    areYouSureYouWantToCancelThisShiftDrop: 101137, // Are you sure you want to cancel this shift drop?
    areYouSureYouWantToCancelThisShiftPickup: 101140, // Are you sure you want to cancel this shift pickup?
    areYouSureYouWantToPickupThisShift: 101138, // Are you sure you want to pickup this shift?
    availableForPickup: 102400, // Available for Pickup
    awaitingPickup: 101166, //Awaiting Pickup
    cancelShiftDrop: 102404, // Cancel Shift Drop
    cancelShiftPickup: 102405, // Cancel Shift Pickup
    confirm: 102401, // Confirm
    dropShift: 101100, // Drop Shift
    droppingEmployee: 101215, // Dropping Employee
    droppersNote: 101103, // Dropper’s Note
    noteByPickingThisUpYouWillBeScheduledToWork: 101147, // Note: By picking this up, you will be scheduled to work the shift
    noteEmployeesAreResponsibleToWorkTheirShiftUntilASuitible: 101144, // Note: Employees are responsible to work their shift until a suitable replacement is approved by the supervisor
    noteYouWillNotBeScheduledForThisShiftUnless: 101146, // Note: You will not be scheduled for this shift unless approved by the supervisor
    pickupShift: 101101, // Pickup shift
    pickupShifts: 101101, // Pickup shifts
    pendingApproval: 101735, // Pending Approval
    requestersNote: 101104, // Requester’s Note
    requestShift: 102394,// Request Shift
    saveNote: 102395,// Save Note
    youAreDroppingAShiftTimeOnDate: 102402, // You are dropping a shift {time} on {date}
    youAreRequestingAShiftTimeOnDate: 102403, // You are requesting a shift {time} on {date}
    youHaveSuccessfullyAddedTheScheduleTime: 102410, // You have successfully added the schedule {time} on {date}
    youHaveSuccessfullyCanceledRequestingShift: 102389, // You have successfully canceled requesting a shift
    youHaveSuccessfullyCancelledADroppedShiftTimeOnDate: 102411, // You have successfully cancelled a dropped shift {time} on {date}
    youHaveSuccessfullyCanceledDroppingShift: 102389, // 'You successfully canceled dropping a shift {time} on {date} for picking up. The manager will be notified.'
    youHaveSuccessfullyRequestedShiftTimeOnDate: 102407, // You have successfully requested shift {time} on {date}
    youHaveSuccessfullySubmittedADropRequest: 102406, // You have successfully submitted a drop request
    youHaveSuccessfullyUpdatedTheShiftPickupNote: 102392, // You have successfully updated the shift pickup note
    youHaveSuccessfullyUpdatedTheShiftDropNote:102393, // You have successfully updated the shift drop note
  }
}
